<div class="payment-method-area" *ngIf="method">
    <h2 class="title">{{ 'PAYMENT_METHOD' | translate }}</h2>
    <div class="payment-method-area__img dark:filter-yellow">
        <img
            *ngIf="method.payment_type !== 'S' && method.code !== 'sveapay'"
            src="assets/pm_{{ method?.code }}.png"
            alt="" />
        <mat-icon *ngIf="method.payment_type === 'S' && method.code === 'sveapay'">account_balance</mat-icon>
    </div>

    <div class="payment-method-area__description">
        <div class="payment-method-name" *ngIf="showTitle">
            <span>{{ method | translateObjectField : 'descr' : lang }}</span>
        </div>
        <div class="payment-method-description">
            <span>{{ 'PAYMENT_METHOD_DESCRIPTION' | translate }}</span>
        </div>
    </div>
</div>
